import { Center, Loader } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { EmptyState } from '@/components/ui/StateViews';
import { PageHeader } from '@/components/ui/PageHeader';
import { pendingReturnTo, rememberReturnTo } from '@/lib/returnTo';
import { useSession } from './useSession';

/**
 * Convenience guards. Authorization is enforced by the server on every request
 * (§64) — these only spare the user a pointless screen.
 */

function SessionLoading() {
  return (
    <Center mih="60vh">
      <Loader size="sm" />
    </Center>
  );
}

export function RequireAuth() {
  const { user, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) return <SessionLoading />;

  if (!user) {
    // Remember where the user was headed so login can send them back.
    // Платёжную ссылку — и через регистрацию в другой вкладке (lib/returnTo).
    rememberReturnTo(location.pathname);
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

export function RequireAdmin() {
  const { user, isAdmin, isLoading } = useSession();

  if (isLoading) return <SessionLoading />;
  if (!user) return <Navigate to="/login" replace />;

  if (!isAdmin) {
    return (
      <>
        <PageHeader title="Раздел недоступен" />
        <EmptyState
          icon={<IconLock size={28} stroke={1.5} />}
          title="Только для администратора"
          description="Этот раздел управляет пользователями и контентом платформы."
        />
      </>
    );
  }

  return <Outlet />;
}

/** Keeps a signed-in user away from the login and registration screens. */
export function RedirectIfAuthenticated() {
  const { user, isLoading } = useSession();

  if (isLoading) return <SessionLoading />;
  // Вход по платёжной ссылке: страница входа сама уводит на оплату, а не на главную.
  if (user) return <Navigate to={pendingReturnTo() ?? '/dashboard'} replace />;

  return <Outlet />;
}
